/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const Container = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexFlow: 'column wrap',
  marginBottom: `${gridSize() * 3}px`,
});
